{
	"translatePaymentMethod": {
		"app": "App",
		"cash": "Cash",
		"creditCard": "Credit card",
		"debitCard": "Debit card",
		"zigPosCredit": "Zig post credit",
		"zigPosDebit": "Zig post debit",
		"voucher": "Voucher",
		"dashboard": "Dashboard",
		"anticipated": "Anticipated",
		"postEvent": "Post event",
		"rappi": "Rappi",
		"appPrePayment": "Payment via app",
		"pix": "Pix",
		"bonus": "Bonus",
		"zigPosCreditInInstallments": "Installment",
		"integratedFoodVoucher": "Food Voucher"
	},
	"translateEventStatus": {
		"created": "Closed",
		"finished": "Closed",
		"running": "Open",
		"canceled": "Canceled"
	}
}
